import type { SvgIconProps } from 'types/icon';
import Close from '@mui/icons-material/Close';
import CloseOutlined from '@mui/icons-material/CloseOutlined';

export const CloseIcon = ({ color = 'inherit', ...props }: SvgIconProps) => (
  <Close color={color} {...props} />
);

export const CloseOutlinedIcon = ({
  color = 'inherit',
  ...props
}: SvgIconProps) => <CloseOutlined color={color} {...props} />;
